import Modal from "src/Components/Modal/Modal";
import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import {
  FuturesExecutionDetailSearch, FuturesExecutionTriggerRow,
  getFuturesExecutionTriggerTable,
} from "src/Requests/futuresMarketMaking";

interface Props { taskId: number | null; onClose: () => void }

const ExecutionTriggers = ({ taskId, onClose }: Props) => taskId == null ? null : <Modal title="تریگرها"
  onClose={onClose} modalBoxClassName="!w-[1400px]"
  UI={<div className="min-h-[240px] overflow-auto" dir="rtl">
    <TableTemplate<FuturesExecutionDetailSearch, FuturesExecutionTriggerRow>
      getDataTable={getFuturesExecutionTriggerTable}
      searchParameters={{ taskId }} refreshTableTime={5000} withSort
      TableUI={({ reports, onAction, sortingType, setSortingType }) =>
        <CommonTableUI reports={reports} onAction={onAction}
          sortingType={sortingType} setSortingType={setSortingType} />}
    />
  </div>} />;

export default ExecutionTriggers;
